import { Trans } from '@lingui/react/macro';

import { type CampaignType } from '@/api/campaign';
import { ColorBadge } from '@/components/typography';
import { getChannelColor } from '@/constants/colors/channel';

type Props = {
  campaigns?: CampaignType[];
};

const CampaignTagList = ({ campaigns }: Props) => {
  return (
    <div className="flex flex-wrap justify-end gap-1">
      {campaigns?.map((campaign) => {
        const channelColor = getChannelColor(campaign.vendor.channel, 0.5);

        return (
          <ColorBadge
            key={campaign.id}
            size="medium"
            variant="solid"
            color={channelColor}
            textColor="dark"
          >
            <Trans>
              {campaign.name} - {campaign.vendor.name} - {campaign.vendor.channel?.name}
            </Trans>
          </ColorBadge>
        );
      })}
    </div>
  );
};

export default CampaignTagList;
